/**
 * `ui/globalNavi.js`
 *  - ヘッダーグローバルナビゲーション周りの処理
 *
 * 使用方法:
 *  - import {initGlobalNavi} from "./globalNavi.js";
 *  - initGlobalNavi();
 */


export class GlobalNavi {
  constructor() {
    this.navItems = [...document.querySelectorAll(".header_nav_list_item")];

    if (this.navItems.length) {
      this.init();
    }
  }

  /** 初期化処理 */
  init() {
    this.setActiveNavItem();
  }

  /** 閲覧中のページに該当するメニューを `active` にする */
  setActiveNavItem() {
    const currentUrl = new URL(window.location.href.split("#")[0]);

    this.navItems.forEach((item) => {
      const link = item.querySelector("a");
      if (!link) return;

      const linkUrl = new URL(link.getAttribute("href"), window.location.origin);
      item.classList.toggle("is-active", linkUrl.pathname === currentUrl.pathname);
    });
  }
}

/** 初期化処理をエクスポート */
export const initGlobalNavi = () => new GlobalNavi();